import { AxiomReportType } from '@/enums/axiom-report.enum'
import { getColumnDetail } from '@/utils/grid-utils/columnUtils'
import { formatCellValue } from '@/utils/tableGridUtils'
import { formatNumber } from '@/utils/utils'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import React, { useEffect, useRef, useState } from 'react'

export const TotalReturnContributionChart: React.FC<{
  data: { data: any[]; series: any[] }
  isFocused: boolean
}> = ({ data, isFocused }) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null)
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'bar',
      height: 520,
      style: {
        fontFamily: '"Source Sans 3", sans-serif',
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      type: 'category',
    },
    yAxis: {
      title: {
        text: 'Total Return Contribution by Scenario / Security',
      },
    },
    tooltip: {
      useHTML: true,
      headerFormat: '',
      pointFormatter: function (this: any): string {
        const formattedValue = formatCellValue(
          formatNumber(this.y),
          getColumnDetail('security_ret_contrib', AxiomReportType.SCEN).format,
        )
        return `
              <span style="color:${this.color}">${this.name}</span>: <b>${formattedValue}</b><br>
          `
      },
    },

    series: [
      {
        name: 'Scenarios',
        colorByPoint: false,
        data: [],
      },
    ],
    drilldown: {
      activeAxisLabelStyle: {
        cursor: 'pointer',
        color: '#303030',
        fontWeight: '400',
        textDecoration: 'none',
      },
      breadcrumbs: {
        position: {
          align: 'left',
        },
      },
      series: [],
    },
  })

  useEffect(() => {
    setChartOptions((chartPrevOptions: any) => ({
      ...chartPrevOptions,

      series: [
        {
          colorByPoint: true,
          data: data.data,
        },
      ],
      drilldown: {
        breadcrumbs: {
          position: {
            align: 'right',
          },
        },
        series: data.series,
      },
    }))
  }, [data])

  return (
    <HighchartsReact
      highcharts={Highcharts}
      ref={chartRef}
      options={chartOptions}
    />
  )
}
